export default __webpack_public_path__ + "static/media/csd-rvg-registration-logo.27c81348.svg";